export default __webpack_public_path__ + "static/media/agua-mineral.86cf0108.jpg";